export default "__VITE_ASSET__CZJwoqP9__"